
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/apply/[company]/[id]",
      function () {
        return require("private-next-pages/jobs/apply/[company]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/apply/[company]/[id]"])
      });
    }
  